/** @format */

import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { z } from "zod";

import { lazyWithRetry } from "@/utils/lazyWithRetry";
import PageLoader from "@/utils/PageLoader";
import { RouteErrorComponent } from "@/utils/RouteErrorComponent";

const WidgetPage = lazyWithRetry(() => import("@/pages/Run/WidgetWrapper"));

// Inherit search params from parent run route
const widgetSearchSchema = z.object({
  detailVehicleID: z.string().optional(),
  playbackLap: z.coerce.number().optional(),
  playbackTimestamp: z.coerce.number().optional(),
  lapStart: z.coerce.number().optional(),
  lapEnd: z.coerce.number().optional(),
  lapProgress: z.coerce.number().optional(),
});

export const Route = createFileRoute("/run/$runID/widget/$widget")({
  validateSearch: widgetSearchSchema,
  component: () => (
    <Suspense fallback={<PageLoader />}>
      <WidgetPage />
    </Suspense>
  ),
  errorComponent: RouteErrorComponent,
  pendingComponent: () => <PageLoader />,
});
